export { default } from "./JWTIFrame";
